export const environment = {
  PRODUCTION: false,
  ENVIRONMENT_NAME: 'qa',
  PUBLIC_KEY: 'lshZsrDTAjQ=',
  SALT_KEY: 'lshZsrDTAjQ=',
  API_URL: 'https://forevermemoriesapidev.alliancetek.net/api/v1',
  PROJECT_NAME: 'forever-web',
  S3_BUCKET_NAME: 'nch4evrpentmorbeif83lp',
  S3_REGION: 'us-east-2',
  S3_ACCESS_KEY_ID: 'AKIAXKIS2FFSDZWOCBQM',
  S3_SECRET_ACCESS_KEY: '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',
  S3_BUCKET_FOLDER_PROFILE_IMAGE: 'profile-images',
  S3_BUCKET_FOLDER_FAMILY_LOGO: 'family-logos',
  S3_BUCKET_FOLDER_MEMBER_PHOTO: 'member-photos',
  GOOGLE_CLIENT_ID: '302740449763-r33jo92krj7gboe4grhabr1n48sr9929.apps.googleusercontent.com',
  FACEBOOK_APP_ID: '',
  APPLE_CLIENT_ID: '',
  APPLE_REDIRECT_URI: '',
};
